export type ImageDimensions = Pick<HTMLImageElement, 'width' | 'height'>;

export const getImageDimensions = async (file: File): Promise<ImageDimensions | undefined> => {
  try {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();

    return { width: img.width, height: img.height };
  } catch (e) {
    console.error(e);
  }
};
